import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { KeycloakAuthorizationService } from '../../modules/keycloak-authz-angular/services/keycloak-authorization.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceRoutingService {

  constructor(
    private deviceService: DeviceDetectorService,
    private router: Router,
    private keycloakAuth: KeycloakAuthorizationService
  ) {}

  /**
   * Redirects to the appropriate default route based on device type and access.
   * Mobile/Tablet: /leads · Desktop: /maps (com emap-menu#view) ou /workspaces
   */
  redirectToDefaultRoute(): void {
    this.router.navigateByUrl(this.getDefaultRoute());
  }

  /**
   * Gets the appropriate default route based on device type and eMap access.
   * @returns string - the default route path
   */
  getDefaultRoute(): string {
    const isMobile = this.deviceService.isMobile() || this.deviceService.isTablet();
    if (isMobile) {
      return '/leads';
    }
    // Sunset eMap: enquanto o usuario tiver a permissao emap-menu#view (hoje
    // concedida via composite emap-legacy) continua em /maps; quando a permissao
    // for revogada, cai em /workspaces — evitando loop de redirect no AuthGuard.
    const hasEmapAccess = this.keycloakAuth.checkAuthorization({ rsname: 'emap-menu', scope: 'view' });
    return hasEmapAccess ? '/maps' : '/workspaces';
  }

  /**
   * Checks if the current device is mobile or tablet
   * @returns boolean
   */
  isMobileDevice(): boolean {
    return this.deviceService.isMobile() || this.deviceService.isTablet();
  }
}
